export default __webpack_public_path__ + "static/media/19c-2x.d9ba2221.png";